// Storage helper - wraps localStorage
// Replaces the Claude artifact window.storage API for production use

const storage = {
  async get(key) {
    try {
      const val = localStorage.getItem(key);
      if (val === null) return null;
      return { key, value: val };
    } catch (e) {
      return null;
    }
  },

  async set(key, value) {
    try {
      localStorage.setItem(key, value);
      return { key, value };
    } catch (e) {
      return null;
    }
  },

  async delete(key) {
    try {
      localStorage.removeItem(key);
      return { key, deleted: true };
    } catch (e) {
      return null;
    }
  },
};

export default storage;
